/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonEyeIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 14"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23.5,7 C23.5,7 18.352,13.5 12,13.5 C5.648,13.5 0.5,7 0.5,7 C0.5,7 5.648,0.5 12,0.5 C18.352,0.5 23.5,7 23.5,7 Z" />
      <circle cx="12" cy="7" r="4" />
      <path d="M12,5 C13.104,5 14,5.896 14,7 C14,8.104 13.104,9 12,9 C10.896,9 10,8.104 10,7" />
    </g>
  </svg>
);

export default PersonEyeIcon;
